/** Local build-time defaults; only calculationPayloadId is set at runtime. */
export const DEMO_WIDGET_CONFIG = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080',
  deliveryCoreUrl: process.env.REACT_APP_DELIVERY_CORE_API_URL || 'http://localhost:8081',
  authIdentityUrl: process.env.REACT_APP_AUTH_IDENTITY_API_URL || 'http://localhost:8101',
  clientCoreUrl: process.env.REACT_APP_CLIENT_CORE_API_URL || 'http://localhost:8100',
  apiKey: process.env.REACT_APP_WIDGET_API_KEY || '',
  googleMapsApiKey: process.env.REACT_APP_WIDGET_GOOGLE_MAPS_API_KEY || '',
  allowExternalPhoneNumber: false,
  maxWidth: 600,
  themeColor: '#266431',
  customerId: process.env.REACT_APP_WIDGET_CUSTOMER_ID || '38008946',
  calculationPayloadId: '',
  refreshIntervalMinutes: 5,
  defaultDeliveryType: 'pickup',
  isDemo: true,
};
